<template>
  <div class="customer-remarks-wrapper">
    <div class="hd">
      填写客户寄语
    </div>
    <div class="bd">
      <bxs-input
        v-model="nameValue"
        class="name"
        label="客户姓名"
        autosize
        type="textarea"
        placeholder="请填写客户姓名"
        @click.once="onceSubmit"
      />
      <bxs-input
        v-model="remakrsValue"
        class="remakrs"
        label="客户寄语"
        type="textarea"
      />
      <bxs-button
        class="change-btn"
        plain
        type="primary"
        size="small"
        @click.prevent="change"
      >
        更换
      </bxs-button>
    </div>
  </div>
</template>

<script>
import { Input, Button } from 'bxs-ui-vue'
import { REMAKRS_OPTIONS } from './config'
import { buriedSubmit } from 'common/js/common'

export default {
  name: 'CustomerRemarks',
  components: {
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    customerName: String,
    customerMessage: String
  },
  data () {
    this.remakrsIndex = 0
    return {}
  },
  computed: {
    nameValue: {
      get () {
        return this.customerName
      },
      set (v) {
        this.$emit('update:customerName', v)
      }
    },
    remakrsValue: {
      get () {
        return this.customerMessage
      },
      set (v) {
        this.$emit('update:customerMessage', v)
      }
    }
  },
  mounted () {
    document.querySelector('.remakrs .bx-input-control').style.height = '88px'
  },
  methods: {
    change () {
      function getIndex () {
        return Math.floor(Math.random() * REMAKRS_OPTIONS.length)
      }
      let index = getIndex()
      while (this.remakrsIndex === index) {
        index = getIndex()
      }
      this.remakrsValue = REMAKRS_OPTIONS[index]
      this.remakrsIndex = index
    },
    onceSubmit () {
      buriedSubmit('kehu')
    }
  }
}
</script>

<style lang="postcss" scoped>
.customer-remarks-wrapper {
  position: relative;
  padding-bottom: 0.42rem;
  color: #333;
  .hd {
    padding: 0.24rem 0.3rem;
    font-size: 0.34rem;
    font-weight: bold;
  }
  .name {
    margin-bottom: 0.42rem;
  }
  .change-btn {
    position: absolute;
    left: 15px;
    top: 170px;
  }
}
</style>

<style>
.customer-remarks-wrapper {
  .name {
    color: #666;
    .bx-input-body {
      border-bottom: 1px solid #ccc;
    }
  }
  .remakrs {
    color: #666;
    .bx-input-value {
      background-color: #fafafa;
    }
  }
  .bx-input {
    .bx-input-label {
      padding: 15px 5px 15px 0;
    }
    .bx-input-body {
      padding: 15px;
    }
  }
}
</style>